module.exports = new __parcel__URL__("shadowstrike.3653c9bc.png").toString();